// extracted by mini-css-extract-plugin
export default {"services":"service_services__9B-2x","container":"service_container__G8wDC","card":"service_card__rM7TZ","desc":"service_desc__7cHk5"};